<template>
  <el-drawer
    custom-class="client-drawer invoice-drawer"
    v-model="dialog.show"
    append-to-body
     @close="dialogClose"
  >
    <template #title>
      <h4>{{dialog.title}}</h4>
    </template>
    <template #default>
      <el-form :model="dialog.data" :rules="dialog.rules" label-position="top" ref="form">
        <template v-if="dialog.type === 'person'">
          <el-form-item label="姓名" prop="accountName">
            <el-input size="mini" v-model="dialog.data.accountName" :disabled="isDisabled"></el-input>
          </el-form-item>

          <el-form-item label="手机号" prop="mobile">
            <el-input size="mini" v-model="dialog.data.mobile" :disabled="isDisabled"></el-input>
          </el-form-item>

          <el-form-item label="邮箱" prop="email">
            <el-input size="mini" v-model="dialog.data.email" :disabled="isDisabled"></el-input>
          </el-form-item>

          <el-form-item label="身份证号" prop="cardNumber">
            <el-input size="mini" v-model="dialog.data.cardNumber"></el-input>
          </el-form-item>
        </template>

        <template v-else>
          <el-form-item label="名称" prop="name">
            <el-input size="mini" v-model="dialog.data.name" @blur="queryEnterpriseCode" :disabled="isDisabled"></el-input>
          </el-form-item>

          <el-form-item label="社会信用代码" prop="uscCode">
            <el-input size="mini" v-model="dialog.data.uscCode"></el-input>
          </el-form-item>
        </template>
      </el-form>
    </template>
    <template #footer class="dialog-footer">
      <el-button type="primary" @click="confirmData" :loading="btnLoading">确定</el-button>
      <el-button @click="dialogClose">取消</el-button>
    </template>
  </el-drawer>
</template>

<script>
export default {
    data () {
        return {
          btnLoading: false
        }
    },
    props: ['dialog'],
    computed: {
        isDisabled () {
            return !this.dialog.data.isCustomerRegister
        }
    },
    watch: {
      "dialog.show" (val) {
        // if (val && this.dialog.data.isCustomerRegister) {
        if (val) {
          this.queryEnterpriseCode()
        }
      }
    },
    methods: {
        confirmData () {
            this.$refs.form.validate(res => {
                if (res) {
                this.btnLoading = true
                this.$post(this.dialog.url, this.dialog.data)
                    .then(({ data }) => {
                    if (data.code === 'C0000') {
                        window.open(data.result)
                        this.dialog.show = false
                    } else {
                        this.$message.error(data.message)
                    }
                    })
                    .catch(err => {
                        console.error(err)
                        this.$message.error('服务器正忙，请稍后再试')
                    })
                    .finally(() => {
                        this.btnLoading = false
                    })
                }
            })
        },
        dialogClose () {
            this.dialog.show = false
            this.$refs.form.clearValidate()
        },
        queryEnterpriseCode () {
          if (!this.dialog.data.name) {
            return false
          }
          this.$get('/sys/esignEnterprise/queryEnterpriseCode', {name: this.dialog.data.name}).then(({data}) => {
            if (data && data.code === 'C0000') {
              this.dialog.data.uscCode = data.result
            }
          })
        }
    },
}
</script>
<style lang="scss">
  .ac-dialog{
    .el-dialog__body{
      padding-bottom: 0px !important;
    }
  }
</style>